import type { LookalikeCluster } from '@repo/contracts';

import { slotChipClass } from './lookalike-colors';

/**
 * The similarity view's legend and its detail at once: each card names what
 * `describeCluster` (`@repo/persona-lookalikes`) found actually distinguishes
 * that group from the population at large — not a fixed label, a computed
 * one. See that function's own doc on how "Mixed — no single trait
 * dominates" is a real, honest outcome here, not a fallback string.
 */
export function LookalikesClusters({
  clusters,
}: {
  clusters: LookalikeCluster[];
}) {
  return (
    <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-3">
      {clusters.map((cluster) => (
        <div
          className="rounded-card border border-hairline bg-warm-alt p-3"
          key={cluster.index}
        >
          <div className="flex items-center gap-2">
            <span
              className={`size-2.5 shrink-0 rounded-pill ${slotChipClass(cluster.index)}`}
            />
            <span className="min-w-0 flex-1 truncate text-ui-strong font-semibold text-text-primary">
              {cluster.label}
            </span>
            <span className="shrink-0 font-mono text-tag tabular-nums text-text-muted">
              {cluster.size.toLocaleString()}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
